import type { Motors } from "gql/api";

export function computeMotorLabel(
  motor: Partial<Motors> | null | undefined
): string | null {
  if (motor) {
    return `${motor.manufacturer}  / ${motor.part_number}`;
  }
  return null;
}
